export default {
    translation: {
        appName: 'Golanix',
        en: 'English',
        he: 'עברית',
        zh: 'Chinese',
        login: 'התחברות',
        logout: 'להתנתק',
        register: 'הירשם',
        name: 'שם',
        email: 'דוא"ל',
        password: 'סיסמה',
        confirmPassword: 'אשר סיסמה',
        sendPasswordResetLink: 'שלח קישור לאיפוס סיסמה',
        homepage: 'דף הבית',
        forgotPassword: 'שכחת את הסיסמא?',
        userNotExistCredentials: 'המשתמש שצוין אינו קיים.',
        emailAlreadyExists: 'האימייל כבר קיים',
        emailHasBeenSent: 'דוא"ל נשלח!',
        checkEmailBox: 'בדוק את תיבת הדואר האלקטרוני שלך.',
        emailHasNotBeenSent: 'האימייל לא נשלח!',
        tryAgain: 'נסה שוב.',
        success: 'הצלח',
        passwordHasBeenChanged: 'הסיסמא שונתה',
        error: 'שגיאה',
        resetPassword: 'לאפס את הסיסמה',
        notFoundTitle: '404 הדף לא נמצא',
        notFoundText: 'לא הצלחנו למצוא את הדף שאתה מחפש.',
        profile: 'הפרופיל שלי',
        workspace: 'מרחב עבודה',
        users: 'Users',
        schoolManager: 'School Manager',
        schoolManagers: 'School Managers',
        teacher: 'Teacher',
        teachers: 'Teachers',
        student: 'Student',
        students: 'Students',
        schoolManagersList: 'School Managers List',
        country: 'Country',
    },
};



// WEBPACK FOOTER //
// ./src/lang/he/he.js